import { render, staticRenderFns } from "./AddNationalityPopup.vue?vue&type=template&id=0d8e3317&"
import script from "./AddNationalityPopup.vue?vue&type=script&lang=js&"
export * from "./AddNationalityPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports